import client from '@/api/base';
import qs from 'qs';

export default {
  async getLeaderInvoiceDoc() {
    const response = await client.get('coaching/engagement/invoice/');
    return response;
  },

  // LGPR
  async getCurrentLGPR() {
    const response = await client.get('engagement/lgpr/current/');
    return response;
  },

  async updateCurrentLGPR(data) {
    const response = await client.patch('engagement/lgpr/current/', data);
    return response;
  },

  async launchCurrentLGPR() {
    const response = await client.post('engagement/lgpr/launch/');
    return response;
  },

  async closeCurrentLGPR() {
    const response = await client.post('engagement/lgpr/close/');
    return response;
  },

  async getSurveyInfo(id) {
    const response = await client.get(`lgpr/survey/${id}/`);
    return response;
  },

  async submitSurvey(id, data) {
    const response = await client.post(`lgpr/survey/${id}/`, data);
    return response;
  },

  /**
   * PAST ENGAGEMENTS
   */
  async getEngagements(params) {
    const response = await client.get(`coaching/engagements/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async getEngagement(id) {
    const response = await client.get(`coaching/engagements/${id}/`);
    return response;
  },

  async getEngagementCoworker(id) {
    const response = await client.get(`coaching/engagements/${id}/supporters/`);
    return response;
  },

  async getEngagementPulse(id, params) {
    const response = await client.get(`coaching/engagements/${id}/pulse/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async getEngagementPulseReport(id, params) {
    const response = await client.get(`coaching/engagements/${id}/pulse/report/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async getEngagementActionPlan(id) {
    const response = await client.get(`coaching/engagements/${id}/ap/`);
    return response;
  },

  async getEngagementFeedforward(id) {
    const response = await client.get(`coaching/engagements/${id}/ff/`);
    return response;
  },

  async getEngagementTasks(id, params) {
    const response = await client.get(`coaching/engagements/${id}/tasks/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async postNewEngagement(data) {
    const response = await client.post('coaching/engagements/', data);
    return response;
  },

  async patchEngagement(id, data) {
    const response = await client.patch(`coaching/engagements/${id}/`, data);
    return response;
  },
};
